
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"fill":"#888","fill-rule":"evenodd","d":"M13.17 7a3.001 3.001 0 015.66 0H20a1 1 0 110 2h-1.17a3.001 3.001 0 01-5.66 0H4a1 1 0 010-2h9.17zM16 7a1 1 0 100 2 1 1 0 000-2zM5.17 17H4a1 1 0 110-2h1.17a3.001 3.001 0 015.66 0H20a1 1 0 110 2h-9.17a3.001 3.001 0 01-5.66 0zM7 16a1 1 0 112 0 1 1 0 01-2 0z","clip-rule":"evenodd"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      